<template>
  <router-link
    :to="{ name: 'home' }"
    @click.native="$store.commit('setCurrentSlide', 0)"
  >
    <img src="/images/logo.svg" alt="Królewskie" class="img" />
  </router-link>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.img {
  width: 107px;

  @include media-down(lg) {
    width: 100px;
  }

  @include media-down(md) {
    width: 46px;
  }
}
</style>
